// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__BHHGd","decoration":"Checkbox_decoration__74xCJ","checked":"Checkbox_checked__kfZUU"};